import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import styled from "styled-components";
import FormButtons from "src/components/CreditRatingForm/FormButtons";
import { StepControls } from "src/components/CreditRatingStepWizard/CreditRatingStepWizard";

const Root = styled("div")`
    text-align: center;

    ${(props) => props.theme.breakpoints.up("tablet")} {
        text-align: left;
    }
`;

const FirstMessage = styled("div")`
    color: ${(props) => props.theme.palette.grey[80]};
    font-size: 14px;
    font-weight: 500;
`;

const SecondMessage = styled("div")`
    color: ${(props) => props.theme.palette.grey[80]};
    font-size: 14px;
    padding-bottom: 10px;

    ${(props) => props.theme.breakpoints.down("tablet")} {
        padding-left: 20px;
    }
`;

const CreditRatingResultNoMatch = ({ cancel, t }: StepControls & WithTranslation) => {
    return (
        <Root>
            <FirstMessage>{t("CreditRatingResultNoMatch.message.first")}</FirstMessage>
            <SecondMessage>{t("CreditRatingResultNoMatch.message.second")}</SecondMessage>
            <FormButtons onCancel={cancel} onSubmit={cancel} />
        </Root>
    );
};

export default withTranslation()(CreditRatingResultNoMatch);
